import { getAPI } from "./Networking";
import { SwayyAPIResponse } from "../../../models/NetworkResponse";
import { SwayyWarehouse } from "../../../models/SwayyWarehouse/SwayyWarehouse";

const getErrorMessage = (error: unknown, fallback: string): string => {
  const axiosMessage = (error as any)?.response?.data?.message;
  if (typeof axiosMessage === "string" && axiosMessage.trim()) {
    return axiosMessage;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
};

export default class SwayyWarehouseAPI {
  getWarehouses = async (): Promise<SwayyWarehouse[]> => {
    try {
      const response = (await getAPI(
        "/v1/catalog/admin/warehouses",
      )) as SwayyAPIResponse<
        SwayyWarehouse[] | { warehouses: SwayyWarehouse[] }
      >;

      const payload = response.data ?? response.result;
      if (!response.success || !payload) {
        throw new Error(response.message || "Failed to fetch warehouses");
      }

      const list = Array.isArray(payload)
        ? payload
        : (payload.warehouses ?? []);
      return list.filter((warehouse) => warehouse.is_active !== false);
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to fetch warehouses"));
    }
  };
}
